package com.shadowings.gero.presentation.screen

import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.Image
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Card
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.ColorFilter
import androidx.compose.ui.hapticfeedback.HapticFeedbackType
import androidx.compose.ui.platform.LocalHapticFeedback
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.tooling.preview.Preview
import androidx.compose.ui.unit.dp
import com.shadowings.gero.data.repository.UniliteralRepository
import com.shadowings.gero.domain.model.CompendioRuleItem
import com.shadowings.gero.presentation.ui.AppTheme
import com.shadowings.gero.presentation.ui.hieroglyphTint
import com.shadowings.gero.presentation.util.DeviceClass
import com.shadowings.gero.presentation.util.rememberDeviceInfo
import compose.icons.FeatherIcons
import compose.icons.feathericons.Lock
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.libro
import org.jetbrains.compose.resources.painterResource
import org.jetbrains.compose.resources.stringResource

@Composable
fun RuleItemCard(
    item: CompendioRuleItem,
    isUnlocked: Boolean,
    onClick: () -> Unit,
    modifier: Modifier = Modifier
) {
    val containerColor = if (isUnlocked) {
        MaterialTheme.colorScheme.surfaceContainer
    } else {
        MaterialTheme.colorScheme.surfaceVariant.copy(alpha = 0.5f)
    }

    val borderColor = if (isUnlocked) {
        MaterialTheme.colorScheme.outlineVariant.copy(alpha = 0.5f)
    } else {
        MaterialTheme.colorScheme.outlineVariant.copy(alpha = 0.2f)
    }

    val deviceInfo = rememberDeviceInfo()
    val iconSize = if (deviceInfo.deviceClass == DeviceClass.WEB_FULL) 40.dp else 32.dp
    val hieroRes = UniliteralRepository.resFromGardinerCode(item.hiero)

    val hapticFeedback = LocalHapticFeedback.current
    Card(
        modifier = modifier
            .fillMaxWidth()
            .clickable(enabled = isUnlocked) {
                hapticFeedback.performHapticFeedback(HapticFeedbackType.LongPress)
                onClick()
            },
        shape = RoundedCornerShape(16.dp),
        colors = CardDefaults.cardColors(containerColor = containerColor),
        border = BorderStroke(1.5.dp, borderColor)
    ) {
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .padding(16.dp),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.spacedBy(12.dp)
        ) {
            Image(
                modifier = Modifier.size(iconSize),
                painter = painterResource(hieroRes ?: Res.drawable.libro),
                contentDescription = null,
                colorFilter = ColorFilter.tint(
                    hieroglyphTint.copy(alpha = if (isUnlocked) 1f else 0.5f)
                )
            )
            Text(
                text = stringResource(item.title),
                modifier = Modifier.weight(1f),
                style = MaterialTheme.typography.titleMedium.copy(fontWeight = FontWeight.Bold),
                color = if (isUnlocked) {
                    MaterialTheme.colorScheme.onPrimaryContainer
                } else {
                    MaterialTheme.colorScheme.onSurface.copy(alpha = 0.6f)
                }
            )
            if (!isUnlocked) {
                Icon(
                    imageVector = FeatherIcons.Lock,
                    contentDescription = null,
                    tint = MaterialTheme.colorScheme.onSurface.copy(alpha = 0.4f),
                    modifier = Modifier.size(18.dp)
                )
            }
        }
    }
}

@Preview
@Composable
private fun RuleItemCardPreview() {
    AppTheme {
        Surface {
            RuleItemCard(
                item = com.shadowings.gero.data.datasource.compendioRules.first(),
                isUnlocked = true,
                onClick = {}
            )
        }
    }
}
